// ConnectMachineIp/constants.ts
export const MACHINE_CONNECTION_TIMEOUT = 30;
